<template>
    <div class="status">
        <div
            :class="
                socketStatus === 'connected'
                    ? 'bc-connected'
                    : 'bc-disconnected'
            "
        >
            Socket estatus:
            {{ socketStatus === 'connected' ? 'Conectado' : 'Conectando' }}
        </div>

        <div>
            <v-btn :disabled="isLoading" color="red" dark @click="resetCache">
                <span v-if="!isLoading" key="delete-icon">
                    <i class="fa fa-trash"></i>
                </span>
                <span v-else key="loading-icon">
                    <i class="fa fa-spinner fa-spin"></i>
                </span>
                &nbsp;
                {{ isLoading ? 'Cargando...' : 'Cache' }}
            </v-btn>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    data() {
        return {
            isLoading: false,
        };
    },
    computed: {
        ...mapGetters({
            bcIsActive: 'socket/bcIsActive',
            socketStatus: 'socket/socketStatus',
            _blockchainEnabled: 'contratos/blockchainEnabled',
        }),
        blockchainEnabled: {
            get() {
                return this._blockchainEnabled;
            },
            set(value) {},
        },
    },
    methods: {
        ...mapActions({
            _toogleBlockchain: 'contratos/toogleBlockchain',
            _getBlockchainStatus: 'contratos/getBlockchainStatus',
            _deleteCache: 'elecciones/deleteCache',
        }),
        resetCache() {
            this.isLoading = true;
            this._deleteCache()
                .then(() => {
                    this.$store.dispatch(
                        'successMessage',
                        'Cache eliminada correctamente'
                    );
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        getBlockchainStatus() {
            this.isLoading = true;
            this._getBlockchainStatus().finally(() => {
                this.isLoading = false;
            });
        },
        toggleBlockchain() {
            if (this.isLoading) {
                return;
            }
            this.isLoading = true;
            this._toogleBlockchain()
                .then(enabled => {
                    this.$store.dispatch(
                        'successMessage',
                        enabled
                            ? 'Blockchain activada'
                            : 'Blockchain desactivada'
                    );
                })
                .finally(() => {
                    this.isLoading = false;
                })
                .then(() => {
                    this.getBlockchainStatus();
                });
        },
    },
    created() {
        this.getBlockchainStatus();
    },
};
</script>

<style lang="scss" scoped>
.status {
    width: 100%;
    display: flex;
    padding: 20px 0;
    justify-content: space-evenly;
    align-items: center;
}

.status div {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.bc-connected {
    color: white;
    font-weight: bolder;
    padding: 5px 0;
}

.bc-disconnected {
    padding: 5px 0;
    color: white;
    font-weight: bolder;
}
</style>
